<template>
  <div class="absolute pin w-full h-full bg-gray900 overflow-hidden rounded" :class="wrapperclass">

    <!-- mobile image -->
    <div v-if="hasMobile"
      class="absolute pin w-full h-full bg-cover bg-center opacity-25 rounded"
      v-bind:style="{ 'background-image': 'url(' + mobileimg + ')' }">
    </div>

    <!-- desktop video -->
    <div v-else-if="videoSrc" class="video-player absolute h-0 w-full">
      <iframe class="absolute pin w-full h-full bg-cover bg-center opacity-25 rounded"
            :src="`${videoSrc}`"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen>
      </iframe>
    </div>

  </div>
</template>

<script>
  import { isMobile } from 'mobile-device-detect';
  // Renders responsive embedded video from _video.twig through video.js.
  export default {
    props: {
      video: {
        type: Object,
        required: true,
      },
      mobileimg: {
        type: String,
        required: true,
      },
      //the naming here gets converted to lowercase somewhere (wrapperClass won't work)
      wrapperclass: {
        type: String,
        default: '',
      },
      params: {
        type: Object,
        default: function () {

          //url params in object form
          return {
              rel: 0,
              background: 1, //vimeo
              controls: 0,
              showinfo:0,
              autopause:0,
              autoplay:1,
              loop:1,
              mute:1
          }
        }
      }
    },
    data () {
      return {
        hasMobile: Boolean(isMobile)
      }
    },
    computed: {
      videoSrc: function () {
        //conver the props params Object into url params
        var params = Object.assign({}, this.params);
        params.playlist = params.playlist || this.video.id;
        var queryParams = Object.keys(params).map(key => key + '=' + params[key]).join('&');

        //build url (note: the props video object gets built at the _video.twig template)
        return this.video.src + '&' + queryParams;
      }
    }
  }
</script>


<style scoped>
  .video-player{
    top: 50%;
    transform: translateY(-50%);
    height: 0;
    padding-bottom:56.25%;

    pointer-events: none;
  }


  /*
   -- welp, this got ugly. We are trying to force full screen video outside of its natural aspect ratio
   --  js might be our best option, typically like to use css for css but here we might need a little help.
  */
  .video--tall .video-player{
    height:100%;
    padding: 0;
  }

  .video--tall iframe {
    width: 100vw;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }

  @media (min-aspect-ratio: 16/9) {
    .video--tall iframe {
      height: 65.25vw;
    }
  }

  @media (max-aspect-ratio: 16/9) {
    .video--tall iframe {
      width: 177.78vh;
    }
  }

  @media (min-width: 1665px) {
    .video--tall .video-player{
      height: 0;
      padding-bottom:56.25%;
    }
    .video--tall iframe {
      width: 100%;
      height: 100%;
    }
  }
</style>
